import {writable} from "svelte/store"
import api from "../shared/api.js"
import Socket from "../shared/sockets.js"

let { subscribe, set, update } = writable({});




function createStore(url){
	var socket

	function setupSocket(){
		if(socket!=null) return socket // only do once
		console.log("setting up socket")
		socket = Socket("")
		socket.on("connected",()=>{
			console.log("forum connected")
		})

		socket.on("forum:savedpost",(data)=>{
			//if someone else updates a post we've already loaded, remove cache and reload
			let cachelength = loaded.length
			let regex = new RegExp("^"+data.parent_id+"\.")
			loaded = loaded.filter(key => !key.match(regex))
			methods.load({parent_id:data.parent_id,postpage:data.page,force:true})
		})
		return socket
	}

	const { subscribe, set, update } = writable([]);
	let loaded = []

  const updateOrAdd = (updated_row=> (rows)=> {
    let hasUpdated = false
    let updated = rows.map((row)=> row.id == updated_row.id ?	(hasUpdated = true && {...row,...updated_row}) :	row ) // dupe rows, update one if found
		if(!hasUpdated) updated.push(updated_row) // not found add new
    return updated
	})
	
	async function handleFiles({post,saved}){
		let files = post.files
		if(!files || !files.length) return saved
		let savedpost = saved.filter(res => res.parent_id == post.parent_id)[0]
		for(let file of files){
			if(file.file.type.match(/^image\//)){
				let path = "/images/forum/post"+savedpost.id
				let res = await api.upload({url:"/duocms/api/forum-upload?_csrf="+csrf,file:file.file,path,name:file.name})
				let filename = res.data.match(/[^/]+$/)[0]
				post.body = post.body.replace(']('+file.name+')',']('+path+'/'+filename+')') // fix paths
			}else{
				let path = "/downloads/forum/post"+savedpost.id
				let res = await api.upload({url:"/duocms/api/forum-upload?_csrf="+csrf,file:file.file,path,name:file.name})
				let filename = res.data.match(/[^/]+$/)[0]
				post.body = post.body.replace(']('+file.name+')',']('+path+'/'+filename+')') // fix paths 
			}
		}
		// resave with file paths updated
		saved = (await api.save({url:"/duocms/api/forums/"+savedpost.id,data:post,method:"PUT"})).data
		return saved
	}

	const methods =  {
		subscribe,
		setupSocket,
		set,
		socket:socket,
		load: async ({parent_id,postpage=0,perpage=10,force}) => { 
			let fullurl = url+"?page="+postpage+"&perpage="+perpage+"&parent_id="+parent_id
			let cachekey = parent_id+"."+postpage
			// if(qs) fullurl+="?"+new URLSearchParams(qs).toString() // querystring encoding
			if(!force && loaded.includes(cachekey)) return // prevent loading twice
			loaded.push(cachekey)
      // set(await api.load({url:fullurl}))
			let res = await api.load({url:fullurl})
			update((rows)=> rows.filter(r => !(r.parent_id == parent_id && r.page==postpage))) // remove all rows before reloading
      res.data.forEach(updated_row =>{
				// save page against row to help pagination
				if(updated_row && updated_row.parent_id == parent_id) updated_row.page = postpage
				update(updateOrAdd(updated_row))
			})
		},
		save: async (data)=>{
			let res = await api.save({url,data})
			let saved = await handleFiles({post:data,saved:res.data})
			// invalidate cache after save for same parent ids to help with pagination
			let regex = new RegExp("^"+data.parent_id+"\.")
			loaded = loaded.filter(key => !key.match(regex))
			saved.forEach(updated_row => {
				// set page to help with pagination
				if(data.page!=null && updated_row.parent_id == data.parent_id) updated_row.page = data.page
				update(updateOrAdd(updated_row))
			})
			socket.emit("forum:savedpost",{parent_id:data.parent_id,page:data.page})
		},
		update:(updated_row)=>{
			update(updateOrAdd(updated_row))
		},
		remove: async (post)=>{
			await api.remove({url:url+"/"+post.id})
			update((rows)=> rows.filter(r => r.id != post.id))
			socket.emit("forum:savedpost",{parent_id:post.parent_id,page:post.page})
			methods.load({parent_id:post.parent_id,force:true}) // reload to fix order etc
		}
	};

	return methods
}



export default createStore("/duocms/api/forums")